<template>
  <div class="def-checkbox">
    <label :class="{'wrapper flex items-center':true,'checkmark_css':cssCheckmark,'checkbox-radio':typeRadio}" :aria-describedby="'label_'+_uid" :for="id">
      <input class="checkbox" :type="isRadioInput?'radio':'checkbox'" v-model="simpleValue" ref="input" @change="updateInputSimple" v-bind:id="id"/>
      <span class="checkmark" v-html="checkedMarker" role="presentation" aria-hidden="true"></span>
      <a v-if='!hyperlinkEmpty' target="_blank" :href="hyperlink" v-html="label" :id="'label_'+_uid" class="checkbox-label-text"></a>
      <span v-if='hyperlinkEmpty' v-html="label" :id="'label_'+_uid" class="checkbox-label-text"></span>
    </label>
  </div>
</template>

<script>
import $ from 'jquery'
export default {
  model: {
    prop: 'modelValue',
    event: 'change'
  },
  data(){
    return {
      isDisabled: false,
      checkedMarker : "",
      refresh: false,
      simpleValue: false,
    }
  },
  props: {
    value: {Type:Object, default: () => ""},
    modelValue: { Type:Object, default: () => null, },
    label: { type: String, required: true},
    trueValue: { default: true },
    falseValue: { default: false },
    object: { Type: Object },
    available: { Type:Number },
    hyperlink: { Type:String, default:() => "" },
    dataOpCnt: { Type:Number },
    hidePrice: Boolean,
    cssCheckmark: Boolean,
    typeRadio: Boolean,
    radioPermaselect: Boolean,
  },
  setup(){
  },
  computed: {
    id() {
      return this._uid;
      // return (this.value.lineId+"") + (this.value.articleId+"") + (this.value.prodId+""); // requires the this.value to have a specific Structure
    },
    config() {
      return window.config;
    },

    hyperlinkEmpty(){
      return typeof this.hyperlink !== "string" || this.hyperlink.length === 0;
    },

    isChecked() {
      if (this.modelValue instanceof Array) {
        return this.modelValue.includes(this.value)
      }
      // Note that `true-value` and `false-value` are camelCase in the JS
      return this.modelValue === this.trueValue
    },
    isRadioInput(){
      return this.typeRadio && this.radioPermaselect;
    },
  },
  watch:{
    /** @param {[{}]} val */
    'modelValue': function (val) {
      if (val instanceof Array) {
        if (this.value.uniqueItemId !== undefined) { // requires the value to have a specific structure
          this.simpleValue = val.findIndex(a=>a.uniqueItemId === this.value.uniqueItemId) !== -1;
        }
        else
        {
          this.simpleValue = val.includes(this.value);
        }
      } else {
        // Note that `true-value` and `false-value` are camelCase in the JS
        this.simpleValue = (val === this.trueValue);
      }
      // console.log("update " + this.simpleValue, this.value.uniqueItemId, val.map(a=>a.uniqueItemId));
      this.$refs.input.checked = this.simpleValue;
    }
  },
  mounted(){
    $(document).on("touchend", function() {
      this.$forceUpdate();
    });
    this.checkedMarker = window.config.CHECKBOX_INNER_SYMBOL;
    this.simpleValue = this.isChecked;
  },
  methods: {
    updateInputSimple() {
      if (this.simpleValue === null && this.isRadioInput) { // fix: radio buttons cant use v-model without a name.
        this.simpleValue = true;
      }
      let isChecked = this.simpleValue;
      // let isChecked = event.target.checked;
      if (this.modelValue instanceof Array) {
        // let newValue = [...this.modelValue]; // previous value
        if (isChecked) {
          // newValue.push(this.value)
          this.modelValue.push(this.value);
        } else {
          // console.log(this.value, newValue);
          if (this.modelValue.indexOf(this.value) !== -1) {
            // newValue.splice(newValue.indexOf(this.value), 1)
            this.modelValue.splice(this.modelValue.indexOf(this.value),1);
          } else {
            let index = this.modelValue.findIndex((val) => JSON.stringify(val) == JSON.stringify(this.value));
            if(index !== -1){
              // newValue.splice(index, 1)
              this.modelValue.splice(index, 1)
            }
          }
        }
        this.$emit('change', this.modelValue)
      } else {
        this.$emit('change', isChecked ? this.trueValue : this.falseValue)
      }
    },
  }
}
</script>

<style lang="scss" scoped>

/* Customize the label (the wrapper) */
.wrapper {
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-size: 16px;
  max-width: 500px;
}
.wrapper .checkbox-label-text {
  line-height: 1.3;
  font-size: 16px;
  height: 21px;
  /* Match .checkmark height for perfect alignment */
  display: flex;
  align-items: center;
}
/* Hide the browser's default checkbox */
.wrapper input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
/* Create a custom checkbox */
.checkmark {
  position: relative;
  height: 21px;
  width: 21px;
  border-radius: 2px;
  background: transparent;
  border: 0.5px solid;
  color: transparent;
  font-size: 20px;
  line-height: 1.3;
  flex-shrink: 0;
  margin-right: 8px; // Add spacing between checkbox and label
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn .checkmark-error .checkmark {
  color: #ff6767;
}
.btn .checkmark {
  vertical-align: middle;
  left: .5rem;
  top: .5rem;
}
/* Create the checkmark/indicator (hidden when not checked) */
.checkmark_css .checkmark::after {
  content: "";
  position: absolute;
  display: none;
}
/* Show the checkmark when checked */
.wrapper.checkmark_css input:checked ~ .checkmark::after {
  display: block;
}
/* Style the checkmark/indicator */
.wrapper.checkmark_css .checkmark::after {
  left: 7px;
  top: 0;
  width: 7px;
  height: 15px;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
/* Accessability : Focus for input Elements should be visible on the Checkmark */
label > input:focus-visible + .checkmark {
  outline: 4px solid var(--accent-color);
  outline-offset: 2px;
}
.checkbox-radio .checkmark { /* cant center a odd element */
  border-radius: 50%;
  /*box-sizing: content-box;*/
}
.wrapper.checkbox-radio .checkmark:after {
  -webkit-transform: none;
  -ms-transform: none;
  transform: none;
  border-radius: 50%;
  border-width: 5px;
  height: 1px;
  width: 1px;
  top: 4px;
  left: 4px;
  box-sizing: content-box;
}


 /**-------------------------------------------*/

.wrapper_2 input:checked ~ .checkmark[role=presentation],
.wrapper_2:focus input ~ .checkmark[role=presentation],
.wrapper_2:active input ~ .checkmark[role=presentation],
.wrapper_2:hover input ~ .checkmark[role=presentation],
.wrapper_2 input ~ .checkmark[role=presentation] {
  background-color: transparent;
  color: transparent;
  vertical-align: middle;
  left: .5rem;
  top: .5rem;
}
.wrapper_2:focus input ~ .checkmark[role=presentation],
.wrapper_2:active input ~ .checkmark[role=presentation] {
  color: transparent;
}
.wrapper_2:hover input ~ .checkmark[role=presentation] {
  color: transparent;
}

.checkbox-radio.wrapper_2 input ~ .checkmark[role=presentation] {
  color: transparent;
  border-radius: 50%;
  //position: relative;
}
.checkbox-radio.wrapper_2 input:checked ~ .checkmark[role=presentation]::before {
  content: "";
  display: block;
  position: absolute;
  height: 100%;
  width: 100%;
  border-radius: 50%;
  border: 5px solid transparent;
  background-clip: content-box;
}

</style>
